import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import PhoneSupport from './PhoneSupport';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PhoneSupportFooter({
  phoneSourceId,
  screen,
  apiName
}) {
  const isTabletOrSmaller = useMedia('tablet');
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      flexDirection: isTabletOrSmaller ? 'column' : 'row',
      justifyContent: isTabletOrSmaller ? 'center' : 'space-between',
      children: [/*#__PURE__*/_jsx(View, {
        maxInlineSize: "600px",
        inlineSize: isTabletOrSmaller ? '100%' : '70%',
        textAlign: isTabletOrSmaller ? 'center' : 'left',
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          "data-selenium-id": "phone-support-footer-header",
          typography: "heading-400",
          textWrap: "wrap",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.phone-supportV2.stillHaveQuestions"
          })
        })
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        display: "inline-flex",
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          screen: screen,
          phoneSourceId: phoneSourceId,
          apiName: apiName
        })
      })]
    })
  });
}
export default PhoneSupportFooter;